
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-assessments",
      function () {
        return require("private-next-pages/my-assessments/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-assessments"])
      });
    }
  